import React from 'react';
import '../App.css'; // Correct relative path

const Footer = () => (
    <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Powered by	EduSmartUp. Power Of Smart Study- Empowering the next generation.</p>
    </footer>
);

export default Footer;
